import { render } from "./RosterDetail.vue?vue&type=template&id=7fbd46dd&scoped=true"
import script from "./RosterDetail.vue?vue&type=script&lang=js"
export * from "./RosterDetail.vue?vue&type=script&lang=js"

import "./RosterDetail.vue?vue&type=style&index=0&id=7fbd46dd&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbd46dd"]])

export default __exports__